import SelectedLandingPage from "./SelectedLandingPage";

export default SelectedLandingPage;
